import React from 'react';
import { FormattedMessage } from 'react-intl';

export const moreWaysToBrowseHeader = (
    <FormattedMessage
        id="SharedMobileMoreWaysToBrowse.header"
        defaultMessage="More Ways To Browse"
    />
);
